import React from 'react'

import enhance from './enhance'
import { FormAdditionText } from './styles'

const ListActionItemFull = ({ handleClick, label, noTopBorder, thin }) => (
  <FormAdditionText noTopBorder={noTopBorder} onClick={handleClick} thin={thin}>
    {label}
  </FormAdditionText>
)

ListActionItemFull.displayName = 'ListActionItemFull'

export default enhance(ListActionItemFull)
